import { SHOP_DIRECTORY_API_HOST } from "@/shared/constants";

import { AsyncPropsMapper, BuilderConfig } from "@/builder/types";

import { fetchCategory, fetchCategoryStores } from "@/pages/api/store-directory/categories";

import { APICategoryProps, APICategoryData } from "@/interfaces/category-interface";

import PreviewStoreCarousel, { Props } from "./preview-stores-carousel";

const mapper: AsyncPropsMapper<APICategoryData> = ({ data }) => {
    const { included = [] } = data;
    const allResults = data.data.concat(included);
    return {
        category: allResults.map((category: APICategoryProps) => ({
            name: category.attributes.name,
            value: category.attributes.slug,
        })),
    };
};

const builderConfig: BuilderConfig<Props> = {
    asyncProps: async (ctx, props) => {
        return {
            initialCategory: await fetchCategory(ctx.locale, props.categorySlug),
            initialCategoryStores: await fetchCategoryStores(ctx.locale, props.categorySlug),
        };
    },
    component: PreviewStoreCarousel,
    config: {
        name: "PreviewStoreCarouselBuilderConfig",
        hideFromInsertMenu: true, // Deprecating in favour of stores-carousel
        inputs: [
            {
                name: "categorySlug",
                type: "dynamic-dropdown",
                required: true,
                options: {
                    url: `${SHOP_DIRECTORY_API_HOST}/api/v1/categories?locale={{targeting.locale.0}}`,
                    mapper: mapper.toString(),
                },
            },
            {
                name: "initialCategory",
                type: "object",
                required: false,
                hideFromUI: true,
            },
            {
                name: "initialCategoryStores",
                type: "list",
                required: false,
                hideFromUI: true,
                defaultValue: [],
            },
            {
                name: "title",
                type: "string",
                required: false,
                defaultValue: "",
            },
            {
                name: "ctaNewTab",
                type: "boolean",
                required: true,
                defaultValue: false,
            },
        ],
    },
};

export default builderConfig;
